import { FC } from 'react'
import { useIntl } from 'react-intl'

export const SUGGESTED_PROMPT_IDS = [
  'How do I remediate this?',
  'Explain the risk and impact',
  'Show exploitation steps',
]

type Props = {
  onPrompt: (text: string) => void
}

const ChatEmptyState: FC<Props> = ({ onPrompt }) => {
  const intl = useIntl()
  return (
    <div className='lum-empty'>
      <div className='lum-orb-lg'>✦</div>
      <h4 className='lum-empty-title'>
        {intl.formatMessage({ id: 'Ask about this vulnerability' })}
      </h4>
      <p className='lum-empty-sub'>
        {intl.formatMessage({
          id: 'I can explain the risk, walk through remediation, or outline exploitation steps.',
        })}
      </p>
      <div className='lum-chips'>
        {SUGGESTED_PROMPT_IDS.map((id) => {
          const text = intl.formatMessage({ id })
          return (
            <button key={id} type='button' className='lum-chip' onClick={() => onPrompt(text)}>
              {text}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default ChatEmptyState
